import OrderSyncModal from './OrderSyncModal'

export default OrderSyncModal
